module.exports = __webpack_public_path__ + "static/media/pagination-loader.7b4598f6.svg";